import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchImageCaptureById,
  deleteImageCaptureById,
} from "../../../lib/api/resources/imageCaptures";
import { ImageCaptureDetailCard } from "./components/ImageCaptureDetailCard";
import { ImageCapturePageList } from "./pages/ImageCapturePageList";

export const ImageCaptureDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["imageCapture", id],
    queryFn: () => fetchImageCaptureById(id as string),
    enabled: !!id,
  });

  const deleteImageCaptureMutation = useMutation({
    mutationFn: () => deleteImageCaptureById(id as string),
    onSuccess: () => {
      navigate(`/image-captures`);
      message.success("ImageCapture succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de ImageCapture",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Flex vertical gap={16}>
            <ImageCaptureDetailCard
              deleteMutation={deleteImageCaptureMutation}
              imageCapture={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>
        <Col span={16}>
          <Flex vertical gap={16}>
            <ImageCapturePageList />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
